<div class="fix-parent-height-center-center">
  <span class="loader" *ngIf="loadingInfo"></span>
</div>

<div #listParent class="list-parent w-100" [hidden]="loadingInfo">

    <div #listTop class="list-top row m-0">
      <div class="col-12 col-lg-7 p-0 align-self-center">
        <span *ngIf="rowsCount !== 0">
          <a mat-icon-button class="p-0 check-all-aligne custom-badge" [matBadge]="selection.selected?.length" [matBadgeHidden]="(selection.selected.length === 0)" matBadgeOverlap="false">
            <mat-checkbox
              color="primary"
              (change)="$event ? masterToggle() : null"
              (click)="$event.stopPropagation()"
              [checked]="selection.hasValue() && selection.selected.length === rowsCount"
              [indeterminate]="selection.hasValue() && selection.selected.length !== rowsCount">
            </mat-checkbox>
          </a>
          <span class="vertical-separator d-inline-block bg-white"></span>
        </span>

        <span *ngIf="selection.hasValue() && rowsCount !== 0">
          <div class="top-list-icons-menu d-inline-block">
            <button
              mat-icon-button
              [matTooltip]="'CERTIFICATES.TABS.PENDING.LABELS.DELETE-CERTS' | translate"
              (click)="onDeleteGlobalCert(selection.selected)">
              <i class="rt-icon rt-delete fs22"></i>
            </button>
          </div>
          <span class="vertical-separator d-inline-block bg-white"></span>
        </span>

        <mat-form-field>
          <input matInput autocomplete="off" (keyup.enter)="$event.stopPropagation(); applyFilter($event.target.value)" [placeholder]="'GLOBAL.SEARCH' | translate" #searchInput />
          <i matSuffix *ngIf="searchInput.value" (click)="$event.stopPropagation(); applyFilter(''); searchInput.value = ''" class="rt-icon rt-cerrar pointer fs18 me-2"></i>
          <i matSuffix (click)="$event.stopPropagation(); applyFilter(searchInput.value)" class="rt-icon rt-search pointer pe-1"></i>
        </mat-form-field>
      </div>

      <div *ngIf="rowsCount > 5" class="col-12 col-lg text-end p-0 align-self-center">
        <mat-paginator
          class="float-end"
          [showFirstLastButtons]="defaultPaginationOpts.showFirstLastButtons"
          [pageSizeOptions]="defaultPaginationOpts.pageSizeOptions"
          [pageSize]="defaultPaginationOpts.pageSize"
          [length]="rowsCount"
          (page)="paginationChange($event)">
        </mat-paginator>
      </div>
      <div *ngIf="rowsCount > 0 && rowsCount <= 5" class="col-12 col-lg text-end align-self-center">
        <app-total-page-items [totalItems]="rowsCount"></app-total-page-items>
      </div>
    </div>

    <div #listContent [style.height.px]="listDinamycHeight" class="list-content matCustomTable certificates w-100">
      <mat-progress-bar *ngIf="sendingInfo && !loadingInfo" class="table-progress-bar" color="primary" mode="indeterminate"></mat-progress-bar>
      <table
        mat-table
        matSort
        matSortDisableClear
        class="agents-table w-100"
        [hidden]="loadingInfo || rowsCount === 0"
        [dataSource]="dataSource"
        [matSortActive]="numberToActiveSortField[userPreference?.orderBy]"
        [matSortDirection]="numberToSortDirection[userPreference?.orderMode]"
        (matSortChange)="sortChange($event)">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="id" sticky>
          <th mat-header-cell *matHeaderCellDef  class="cell-initial" (click)="$event.preventDefault(); $event.stopPropagation()"></th>
          <td mat-cell *matCellDef="let row" (click)="$event.preventDefault()"  class="cell-initial">
            <ng-container *ngIf="checkAllLoading; then checkBoxSpinner; else checkBoxColumn">
            </ng-container>
            <ng-template #checkBoxSpinner>
              <mat-spinner [diameter]="16"></mat-spinner>
            </ng-template>
            <ng-template #checkBoxColumn>
              <mat-checkbox
                color="primary"
                [id]="'check_pending_' + row.id"
                [checked]="selection.isSelected(row.id)"
                [attr.data-selenium]="'checkbox-pending-cert-select-' + row.id"
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row.id) : null">
              </mat-checkbox>
            </ng-template>
          </td>
        </ng-container>

        <!-- alias Column -->
        <ng-container matColumnDef="alias">
          <th mat-sort-header mat-header-cell *matHeaderCellDef class="cell-normal" (click)="$event.preventDefault(); $event.stopPropagation()">
            {{ 'CERTIFICATES.TABS.PENDING.LABELS.NAME' | translate }}
          </th>
          <td mat-cell *matCellDef="let row" class="cell-normal" [satPopoverAnchor]="tooltipAlias" (mouseenter)="tooltipAlias.open()" (mouseleave)="tooltipAlias.close()">
            <div *ngIf="row.alias" class="text-ellipsis-2">
              {{ row.alias }}
            </div>

            <span class="text-ellipsis-2 text-danger" *ngIf="!row.alias">
              {{ 'CERTIFICATES.TABS.PENDING.LABELS.NO-NAME' | translate }}
            </span>

            <sat-popover #tooltipAlias horizontalAlign="start" verticalAlign="above">
              <div style="max-width:300px; word-break: break-all;">
                <small class="d-inline-block w-100 p-2" *ngIf="row.alias">
                  <b class="fw-bold">{{ 'CERTIFICATES.TABS.PENDING.LABELS.NAME' | translate }}: </b> {{row.alias}}
                </small>

                <small class="d-inline-block w-100 p-2 text-danger" *ngIf="!row.alias">
                  <b class="fw-bold">{{ 'CERTIFICATES.TABS.PENDING.LABELS.NAME' | translate }}: </b> {{'CERTIFICATES.TABS.PENDING.LABELS.NO-NAME' | translate}}
                </small>
              </div>
            </sat-popover>
          </td>
        </ng-container>

        <!-- uploadedTime To Column -->
        <ng-container matColumnDef="uploadedTime">
          <th mat-sort-header mat-header-cell *matHeaderCellDef class="cell-normal" (click)="$event.preventDefault(); $event.stopPropagation()">
            {{ 'CERTIFICATES.TABS.PENDING.LABELS.UPLOADEDON' | translate }}
          </th>
          <td mat-cell *matCellDef="let row" class="cell-normal" [satPopoverAnchor]="tooltipExpiryTime" (mouseenter)="tooltipExpiryTime.open()" (mouseleave)="tooltipExpiryTime.close()">
            <span class="text-ellipsis-2" *ngIf="row.uploadedTime">
              {{row.uploadedTime | dateMultiLang:currentLang}}
            </span>
            <span class="text-ellipsis-2 text-danger" *ngIf="!row.uploadedTime">
              {{'GLOBAL.NO-DATE' | translate}}
            </span>
            <sat-popover #tooltipExpiryTime horizontalAlign="start" verticalAlign="above">
              <div style="max-width:300px; word-break: break-all;">
                <small class="d-inline-block w-100 p-2" *ngIf="row.uploadedTime">
                  <b class="fw-bold">{{ 'CERTIFICATES.TABS.PENDING.LABELS.UPLOADEDON' | translate }}: </b> {{row.uploadedTime | dateMultiLang:currentLang}}
                </small>
                <small class="d-inline-block w-100 p-2 text-danger" *ngIf="!row.uploadedTime">
                  <b class="fw-bold">{{ 'CERTIFICATES.TABS.PENDING.LABELS.UPLOADEDON' | translate }}: </b> {{'GLOBAL.NO-DATE' | translate}}
                </small>
              </div>
            </sat-popover>
          </td>
        </ng-container>

        <!-- columnAction Column -->
        <ng-container matColumnDef="columnAction" stickyEnd>
          <th mat-header-cell *matHeaderCellDef class="cell-final">
            {{'CERTIFICATES.TABS.PRIVATE.LABELS.ACTIONS' | translate}}
          </th>
          <td mat-cell *matCellDef="let row" class="cell-final">
            <button mat-icon-button (click)="$event.stopPropagation();" [matMenuTriggerFor]="columnaction" data-selenium="row-action-btn" [satPopoverAnchor]="tooltipActions" (mouseenter)="tooltipActions.open()" (mouseleave)="tooltipActions.close()">
              <i class="rt-icon rt-more-1 fs-30"></i>
            </button>

            <sat-popover #tooltipActions horizontalAlign="start" verticalAlign="above">
              <div style="max-width:300px; word-break: break-all;">
                <small class="d-inline-block w-100 p-2">
                  <b class="fw-bold">{{ 'GLOBAL.ACTIONS' | translate }}</b>
                </small>
              </div>
            </sat-popover>

            <mat-menu #columnaction="matMenu" xPosition="before" yPosition="below" class="profile-menu" [overlapTrigger]="false">

              <button mat-menu-item [attr.data-selenium]="'button-pending-list-action-active-cert-' + row.id" (click)="$event.stopPropagation(); onAtivateCert(row.id)">
                <i class="rt-icon rt-cheque and-text me-2 fs22"></i>
                <span >{{ 'GLOBAL.ACTIVATE-CERTIFICATE-TITLE' | translate }}</span>
              </button>
              <mat-divider></mat-divider>

              <button mat-menu-item [attr.data-selenium]="'button-pending-list-action-delete-' + row.id" (click)="$event.stopPropagation(); onDeleteIndividualCert(row.id, row.alias)">
                <i class="rt-icon rt-delete and-text me-2 fs22"></i>
                <span >{{ 'GLOBAL.DELETE' | translate }}</span>
              </button>

            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsPreloadCert; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsPreloadCert" class="mat-table-row pointer" (click)="selection.toggle(row.id)"></tr>
      </table>

      <div *ngIf="rowsCount === 0 && !sendingInfo" class="col-12 p-1">
        <div *ngIf="dataSource?.filter" class="notify notify-info wb-ball">
          <span class="notify-message text-center">
            {{ 'GLOBAL.NO-RESULTS-FOR' | translate }} <b class="fw-bold">"{{ dataSource.filter }}"</b>.
          </span>
        </div>

        <div *ngIf="!dataSource?.filter" class="notify notify-info wb-ball">
          <span class="notify-message text-center">
            {{ 'GLOBAL.NO-RESULTS' | translate }}
          </span>
        </div>
      </div>
    </div>
</div>
